export const railBrands = [
  {
    name: "Amtrak",
    code: "AMTK",
    slug: "amtrak",
    region: "United States",
    summary:
      "Amtrak is the national passenger rail operator in the United States, connecting major cities, regional corridors, and scenic long-distance routes across the country.",
  },
  {
    name: "VIA Rail",
    code: "VIA",
    slug: "via-rail",
    region: "Canada",
    summary:
      "VIA Rail is Canada's national passenger rail service, operating intercity and long-distance train routes from coast to coast.",
  },
];

export const findRailBrandBySlug = (slug) =>
  railBrands.find((brand) => brand.slug === slug);
